import { ApolloCache, FetchResult } from "@apollo/client";
import {
	clearTimelineQueryCache,
	StudentMedicalEvent,
	StudentMedicalEventCreateInput,
	StudentMedicalEventCreateMutation,
	StudentMedicalEventDeleteMutation,
	StudentMedicalEventUpdateInput,
	StudentMedicalEventUpdateMutation,
} from "../../../Utilities";
import * as StudentMedicalEventFormValues from "./form-values";

export function customUpdateCacheForCreate(
	_input: StudentMedicalEventCreateInput,
	cache: ApolloCache<any>,
	_result: Omit<FetchResult<StudentMedicalEventCreateMutation, Record<string, any>, Record<string, any>>, "context">,
) {
	clearTimelineQueryCache(cache);
}

export function customUpdateCacheForUpdate<
	K extends keyof StudentMedicalEventFormValues.Detail = keyof StudentMedicalEventFormValues.Detail,
>(
	_input: StudentMedicalEventUpdateInput,
	_initialFormValues: StudentMedicalEventFormValues.DetailSubset<K>,
	_cache: ApolloCache<any>,
	_result: Omit<FetchResult<StudentMedicalEventUpdateMutation, Record<string, any>, Record<string, any>>, "context">,
) {}

export function customUpdateCacheForDelete(
	_id: StudentMedicalEvent["id"],
	_cache: ApolloCache<any>,
	_result: Omit<FetchResult<StudentMedicalEventDeleteMutation, Record<string, any>, Record<string, any>>, "context">,
) {}
